enum ToBeCheckedAt {
  VERY_SOON = 'very_soon',
  SOON = 'soon',
  FUTURE = 'future',
}

export default ToBeCheckedAt;
